var map = {
	"./apple-touch-icon-114x114.png": "0SmT",
	"./apple-touch-icon-120x120.png": "RL1v",
	"./apple-touch-icon-144x144.png": "oBWf",
	"./apple-touch-icon-152x152.png": "k5oh",
	"./apple-touch-icon-180x180.png": "kY5W",
	"./apple-touch-icon-57x57.png": "xO7V",
	"./apple-touch-icon-60x60.png": "mYrb",
	"./apple-touch-icon-72x72.png": "lzRn",
	"./apple-touch-icon-76x76.png": "3GEo"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1yXu";